import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComponentsListComponent } from './components-list/components-list.component';


const routes: Routes = [
  {
    path: '',
    component: ComponentsListComponent,
    title: 'components'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComponentsMgmtRoutingModule { }
